import Vue from 'vue'
import { repository, fullCollection, datatableCollection } from '@/packages/vue-repository'

const endpoint = 'tags'

export default ({ api }) => {
  return new Vue({
    mixins: [
      repository({ api, endpoint }),
      fullCollection({ api, endpoint }),
      datatableCollection({ api, endpoint })
    ]
  })
}